module.exports = __webpack_public_path__ + "img/james.801aff99.png";